import { defineEvent } from '../types/event';
export var COUPON_MODAL_SMS_SUCCESS = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        },
        {
            name: 'Heap',
            transform: function (input) { return ({
                eventName: 'coupon-modal_sms-submission',
                has_past_purchases: input.customer.returning
            }); }
        },
        {
            name: 'GTM',
            transform: function (input) { return ({
                eventName: 'SMS List Sign-Up',
                customer: {
                    phone: input.customer.phone
                }
            }); }
        }
    ]
});
